if (!customElements.get('product-content')) {
  customElements.define('product-content', class ProductContent extends HTMLElement {
    constructor() {
      super();

      this.productInfoWraper = document.querySelector('.product__info-wrapper');

      const parent = this.parentElement;
      const previousElement = parent ? parent.previousSibling : null;
      const followsProductPageSection = previousElement ? previousElement.classList.contains('product-page-section') : false;

      if (this.productInfoWraper && followsProductPageSection) {
        this.productPageSection = previousElement;
        this.wrapProductSections();
        this.syncMainWrapHeight();
      } else if (this.productInfoWraper && !followsProductPageSection) {
        const productPageSection = document.querySelector('.product-page-section');
        if (productPageSection) {
          productPageSection.classList.add('product-static-buy-tools');
        }
      }

      this.handleCollapsibleBlocks();
    }

    // Wrap every .product-section in one .product-section-main-wrap (what the
    // old jQuery wrapAll did): the wrapper takes the first section's place and
    // the sections move into it in document order.
    wrapProductSections() {
      const sections = Array.from(document.querySelectorAll('.product-section'));
      if (!sections.length || document.querySelector('.product-section-main-wrap')) return;
      const wrap = document.createElement('div');
      wrap.className = 'product-section-main-wrap';
      sections[0].parentNode.insertBefore(wrap, sections[0]);
      sections.forEach((section) => wrap.appendChild(section));
    }

    // POD (2026-09-03): the buy column is position:absolute over the wrap, so the
    // wrap must be at least as tall as the column or the next section slides under
    // it. Follows the column as the app block grows/shrinks.
    syncMainWrapHeight() {
      const wrap = document.querySelector('.product-section-main-wrap');
      const content = this.productInfoWraper && this.productInfoWraper.querySelector('.product__info-container');
      if (!wrap || !content || typeof ResizeObserver === 'undefined') return;
      const apply = () => {
        const padTop = parseFloat(getComputedStyle(this.productInfoWraper).paddingTop) || 0;
        const needed = Math.ceil(content.getBoundingClientRect().height + padTop + 48);
        wrap.style.minHeight = needed + 'px';
      };
      new ResizeObserver(apply).observe(content);
      apply();
    }

    removeProductInfoHeight() {
      this.productInfoWraper.style.height = "";
    }

    handleCollapsibleBlocks() {
      const details = this.querySelectorAll('.product__collapsible-details');
      const RO = new ResizeObserver(entries => {
        return entries.forEach(entry => {
          const detail = entry.target;
          const detailWidth = +detail.dataset.width;
          const roundedEntrySize = Math.round(entry.contentRect.width);
          if (detailWidth !== roundedEntrySize) {
            detail.removeAttribute('style');
            this.setHeight(detail);
          }
        })
      });

      details.forEach(detail => {
        RO.observe(detail);
      });
    }

    setHeight (detail) {
      detail.open = true;
      const rectOpen = detail.getBoundingClientRect();
      detail.style.setProperty('--expanded', `${rectOpen.height}px`);

      detail.open = false;
      const rectClose = detail.getBoundingClientRect();
      detail.style.setProperty('--collapsed', `${rectClose.height}px`);
      detail.dataset.width = Math.round(rectClose.width);
    }
  });
}
